import script from "./signable-document-history-modal.vue?vue&type=script&setup=true&lang=ts"
export * from "./signable-document-history-modal.vue?vue&type=script&setup=true&lang=ts"

import "./signable-document-history-modal.vue?vue&type=style&index=0&id=3145919c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3145919c"]])

export default __exports__